import { Box, Typography } from "@mui/material";
import type { Theme } from "../../../constants/themeConstants";
import { styled } from "styled-components";

export const SlideContainer = styled(Box)<{ $imageUrl: string }>`
  height: 100%;
  min-height: calc(max(736px, 80vh));
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  background-image: url("${(props) => props.$imageUrl}");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;
export const SlideCard = styled(Box)`
  position: relative;
  z-index: 1;
  max-width: 1280px;
  width: 100%;
`;
export const SlideContent = styled(Box)`
  padding: 32px;
  margin-left: 32px;
  max-width: 520px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  background-color: ${(props) => (props.theme as Theme).colors.white};
  color: ${(props) => (props.theme as Theme).colors.textColor};
  @media (max-width: 768px) {
    max-width: unset;
    left: 0;

    padding: 32px 16px;
    width: auto;
    margin-left: 16px;
    margin-right: 16px;
  }

  && {
    .MuiButton-root {
      background-color: ${(props) => (props.theme as Theme).colors.primary};
      color: ${(props) => (props.theme as Theme).colors.textColor};

      gap: 10px;
      padding: 16px;
      box-shadow: none;
      border-radius: 0;

      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 700;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: -0.02;
      text-transform: uppercase;
    }
  }
`;

export const HeroEyebrow = styled(Typography)`
  && {
    color: ${(props) => (props.theme as Theme).colors.secondary};
    font-family: "Indie Flower", "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 28px;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0;

    padding-bottom: 8px;
  }
`;

export const HeroHeadline = styled.h1`
  && {
    margin-block-start: 0;
    margin-block-end: 0;

    color: ${(props) => (props.theme as Theme).colors.textColor};
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 100%;

    padding-bottom: 24px;
    width: 80%;
    min-width: 300px;

    @media (max-width: 768px) {
      font-size: 32px;
      width: 100%;
    }
  }
`;

export const HeroLead = styled(Typography)`
  && {
    color: ${(props) => (props.theme as Theme).colors.textColor};
    font-size: 20px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    line-height: 1;
    letter-spacing: 0;

    padding-bottom: 32px;
  }
`;
